;(function () {
  window.HB = window.HB || {}
  window.HB.isMobile = document.documentElement.classList.contains("mobile")
  window.HB.isDesktop = !window.HB.isMobile
})()
